import { render, staticRenderFns } from "./FormDetail.vue?vue&type=template&id=376db14e"
import script from "./FormDetail.vue?vue&type=script&lang=js"
export * from "./FormDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports